import React from 'react';
import styled from 'styled-components';
import { FaSave } from 'react-icons/fa';

const Barra = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 10px;
  padding: 8px 12px;
  background: #f4f6f6;
  border-radius: 8px;
  flex-wrap: wrap;
`;

const Texto = styled.span`
  font-size: 12.5px;
  color: ${(props) => (props.$destaque ? '#008080' : '#666')};
  font-weight: ${(props) => (props.$destaque ? 600 : 400)};
`;

const Botao = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 8px;
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  background: ${(props) => (props.$destaque ? '#008080' : 'white')};
  color: ${(props) => (props.$destaque ? 'white' : '#008080')};
  border: 1px solid #008080;
  &:hover { background: ${(props) => (props.$destaque ? '#006666' : '#e6f7f5')}; }
  &:disabled { opacity: 0.6; cursor: not-allowed; }
`;

// Barra de status + botão pra salvar/atualizar um cliente ou veículo no cadastro,
// a partir dos dados preenchidos numa tela de documento (Procuração, Documentos
// Complementares...). Reflete a mesma situação (vazio/novo/alterado/igual/desconhecido)
// calculada por `situacaoCadastro` (src/others/cadastroSync.js).
const BarraCadastro = ({ situacao, salvando, onSalvar, rotulo }) => {
  const destaque = situacao.tipo === 'novo' || situacao.tipo === 'alterado';
  const desabilitado = salvando || situacao.tipo === 'vazio' || situacao.tipo === 'igual';
  return (
    <Barra>
      <Texto $destaque={destaque}>{situacao.texto}</Texto>
      <Botao type="button" onClick={onSalvar} disabled={desabilitado} $destaque={destaque}>
        <FaSave size={12} /> {salvando ? 'Salvando...' : rotulo}
      </Botao>
    </Barra>
  );
};

export default BarraCadastro;
